export default {"src":"/_next/static/media/Delaware.00659161.svg","height":1501,"width":800,"blurWidth":0,"blurHeight":0};